function getStaticUrl(url: string): string {
  return '/gr-static' + url
}

export {getStaticUrl}
